import React from 'react';

// Opt in only from the connected-mailbox creation form. Shared editors keep
// their default control appearance and behavior on existing/legacy screens.
export const CreationControls = React.createContext(false);
export const useCreationControls = () => React.useContext(CreationControls);
